import { site } from '@yola/ws-sdk';

export default (value, currentPageId) => {
  const pages = site.accessors.getPages();
  const currentPage = site.accessors.getPage(currentPageId);
  const isMultilingualSite = site.verifiers.isMultilingualSite();

  const startPathPart = isMultilingualSite ? `/${currentPage.locale}` : '';
  const endPathPart = value.endsWith('/') ? '' : '/';
  const currentPagePath = `${startPathPart}${value}${endPathPart}`;

  return !pages.some(({ id, path }) => path === currentPagePath && id !== currentPageId);
};
